import firebase from 'firebase';

export const firebaseConfig = {
  apiKey: "AIzaSyCbj0ZOkcxkTjZuIf2dzUZkxQh0psX7VJs",
  authDomain: "pandemic-control.firebaseapp.com",
  projectId: "pandemic-control",
  storageBucket: "pandemic-control.appspot.com",
  messagingSenderId: "445434749637",
  appId: "1:445434749637:web:5b1143b6fec3a3bd53c6ac",
  measurementId: "G-X3GCS1YEJE"
};
firebase.initializeApp(firebaseConfig);
export default firebase;
